module.exports = __webpack_public_path__ + "img/join_block_bg.61950bf.png";